import reducer from "../reducers";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from 'redux-thunk';

// dev tools middleware
const composeSetup = (process.env.NODE_ENV !== 'production' && typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose

const store = createStore(
    reducer,
    composeSetup(applyMiddleware(thunk))
);
export default store;